import type { ListAction } from '~/client/src/shared/lists/core'
import { setIdsSelected } from '~/client/src/shared/lists/core'

interface FilteredSelection {
  readonly filteredSelectableIds: readonly string[]
  readonly allFilteredSelected: boolean
}

export function toggleAllFilteredSelection(
  selection: FilteredSelection,
  dispatch: (action: ListAction) => void,
): void {
  dispatch(
    setIdsSelected(
      selection.filteredSelectableIds,
      !selection.allFilteredSelected,
    ),
  )
}
